import React from 'react';
import "./NativeDatePicker.scss";
import TextField from "@mui/material/TextField";

const MAX_DATE = "2150-01-01";
const MIN_DATE = "1900-01-01";

const NativeDatePicker = (props) => {

  const className = props.className
      ? `${props.className} instream-native-date-picker`
      : "instream-native-date-picker";

  const handleChange = (event) => {
      props.onSelect(event.target.value);
  };

  const adjustChange = (event) => {
      let selectedDate = event.target.value;
      if (new Date(selectedDate).getTime() > new Date(props.maxDate ? props.maxDate : MAX_DATE).getTime()) {
          selectedDate = props.maxDate ? props.maxDate : MAX_DATE;
      } else if (new Date(selectedDate).getTime() < new Date(props.minDate ? props.minDate : MIN_DATE).getTime()) {
          selectedDate = props.minDate ? props.minDate : MIN_DATE;
      }
      props.onSelect(selectedDate);
  };

  return (
      <div className={className}>
          <TextField
              {...props}
              label={props.label}
              type="date"
              value={props.selectedDate}
              InputLabelProps={{
                  shrink: true,
              }}
              onChange={handleChange}
              onBlur={adjustChange}
              inputProps={{
                  min: props.minDate ? props.minDate : MIN_DATE,
                  max: props.maxDate ? props.maxDate : MAX_DATE
              }}
              error={props.hasError || props.hasError}
          />
      </div>
  );
};

export default NativeDatePicker;
